var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSemnulExclamarii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.18 113.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5f2f74;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.67,0C70.31,0,83,0,95.61.06c11.26.1,18.56,6.94,19,18.08.89,25.1.72,50.22.15,75.32-.31,13.38-7.32,20-20.77,20q-37.18.09-74.37-.24C7.52,113.15.15,106.08.07,94-.09,68.6,0,43.16.3,17.72.41,7.52,8.33.14,18.73.05,31.71,0,44.69,0,57.67,0ZM66.3,32.49h-.17c.13-2.15.15-4.31.43-6.44a6.25,6.25,0,0,0-2.16-5.73C61.16,17.45,52.26,18.07,49,21c-1.07,1-1.2,2-1.45,3.39-.94,5.05,1.11,9.77,1.24,14.72.21,8.55,1.06,17.09,1.81,25.62.42,4.86,4.29,4.18,7.57,4.31s5.67-.62,5.93-4.39Q65.21,48.6,66.3,32.49Zm0,54.08c.08-5.75-2.79-9.08-8-9.28-6.38-.25-9.84,2.93-9.86,9.07,0,5.16,3,8.23,8.33,8.41C62.75,95,66.22,92,66.3,86.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSemnulExclamarii);
export default __webpack_public_path__ + "static/media/IconSemnulExclamarii.1f8e2c15d8e70cbf441d422c37f4b5b5.svg";
export { ForwardRef as ReactComponent };